<template>
  <b-card class="reports-browser shadow grid-stack-item-content flex-container">
    <div slot="header">
      <window-header cmp-title="Reports" widget-name="reports"></window-header>
    </div>
    <div class="flex-full-height w-100">
      <iframe src="/api/reports-proxy/" frameborder="0" ></iframe>
    </div>
    <window-footer></window-footer>
  </b-card><!-- END REPORTS BROWSER -->
</template>
<script>

import WindowHeader from '../common/WindowHeader'
import WindowFooter from '../common/WindowFooter'
export default {
  name: 'reports-browser',
  components: {WindowHeader, WindowFooter},
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/ReportsBrowser.vue